import { render, staticRenderFns } from "./ChatOrderProfileCard.vue?vue&type=template&id=1600bc25&scoped=true&"
import script from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileCard.vue?vue&type=style&index=0&id=1600bc25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600bc25",
  null
  
)

export default component.exports